"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var isProd = _enviro.default.getShort() === 'prod';
var GoogleTracking = {
  _fireGaEvent: function _fireGaEvent(eventGroup, eventName) {
    var product = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'CRM';

    try {
      if (isProd) {
        return window.ga('send', 'event', product, eventGroup, eventName);
      }
    } catch (error) {
      console.debug(error);
    }
  },
  trackActivation: function trackActivation() {
    return this._fireGaEvent('User Activated', 'User Activated');
  }
};
var _default = GoogleTracking;
exports.default = _default;
module.exports = exports.default;